import React, { useContext, useEffect } from "react";
import { useInView } from "react-intersection-observer";

import ActiveComponentContext from "../../../contexts/ActiveComponentContext";
import useOutputReportStore from "../../../store/OutputReport.store";
import { getReportType } from "../../../utils/helpers/dataTable";

import OneSheeterReportCash from "./OneSheeterReportCash";
import OneSheeterReportTransition from "./OneSheeterReportTransition";

import "./OneSheeterReport.scss";

const OneSheeterReport = () => {
  const data = useOutputReportStore((state) => state.data);
  const { active: activeId, setActive: setActiveComponent } = useContext(
    ActiveComponentContext
  );
  const { ref, entry } = useInView({
    /* Optional options */
    threshold: 0.25,
    trackVisibility: true,
    delay: 100,
  });

  useEffect(() => {
    if (entry?.isVisible && entry?.target?.id !== activeId) {
      setActiveComponent(entry.target.id);
    }
  }, [entry, setActiveComponent, activeId]);

  if (!data) {
    return null;
  }

  const reportType = getReportType(data);
  const reportContent = {
    transition: <OneSheeterReportTransition />,
    cash: <OneSheeterReportCash />,
  };

  return (
    <article
      ref={ref}
      id="OneSheeterSummary"
      className="report-article one-sheeter"
    >
      <header className="section-title report-article__header">
        <h1 className="section-title__heading">Proposal 1</h1>
        <div className="section-title__sub">{data.Cover.Strategy}</div>
      </header>

      <div className="report-article__content one-sheeter__grid">
        {reportContent[reportType]}
      </div>
    </article>
  );
};

export default OneSheeterReport;
